/**
 * Feature flag names. `CONSTANT_CASE` only!!!
 */
export const FeatureFlagNames = [
  // please keep flags in alphabetical order
  'PROJECT_COLLECTION',
  // please keep flags in alphabetical order
] as const;

/**
 * Feature flag enum-like object.
 * Feature flag names are keys and values at the same time.
 */
export const FeatureFlag = FeatureFlagNames.reduce(
  (acc, featureName) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    acc[featureName] = featureName;
    return acc;
  },
  {} as { [K in (typeof FeatureFlagNames)[number]]: K }
);
